import { render, staticRenderFns } from "./search.vue?vue&type=template&id=55c1ed21&scoped=true&"
import script from "./search.vue?vue&type=script&lang=ts&"
export * from "./search.vue?vue&type=script&lang=ts&"
import style0 from "./search.vue?vue&type=style&index=0&id=55c1ed21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c1ed21",
  null
  
)

export default component.exports